import React from 'react';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

export interface RatingInputProps {
  name?: string;
  disabled?: boolean;
  value?: number;
  onChange?: (e: number) => void;
  showHint?: boolean;
  hintText?: string;
}

export const RatingInput: React.FC<RatingInputProps> = ({
  name = 'rating',
  disabled = false,
  value,
  onChange,
  showHint = true,
  hintText = 'Click on the stars to rate'
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formikProps = useFormikContext<any>();

  const handleRatingChange = (_: React.ChangeEvent<unknown>, newValue: number | null) => {
    if (newValue !== null) {
      if (formikProps && formikProps.setFieldValue) {
        formikProps.setFieldValue(`${name}`, newValue);
      }

      if (onChange) {
        onChange(newValue);
      }
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Rating
        name={`${name}`}
        value={formikProps.values.rating ?? value}
        onChange={handleRatingChange}
        icon={<StarIcon fontSize="inherit" />}
        emptyIcon={<StarBorderIcon fontSize="inherit" />}
        size="large"
        disabled={disabled}
      />

      {!disabled && showHint && (
        <Typography variant="caption" color="text.secondary" mt={0.5}>
          {hintText}
        </Typography>
      )}
    </Box>
  );
};

